import { defineStore } from 'pinia';

/**
 * Globally pauses analytics tracking while active.
 * Use case: when a learning activity is being previwed by a teacher,
 * avioid activities' events to pollute analytics.
 */
export const useAnalyticsSuppressionStore = defineStore('analyticsSuppression', () => {
  const isSuppressed = ref(false);

  const setSuppressed = (value: boolean) => {
    isSuppressed.value = value;
  };

  return { isSuppressed, setSuppressed };
});
